import type { UserPermission } from './common.models';

export const UserPermissionLevel = {
  Full: 'FULL',
  Read: 'READ',
} as const satisfies Record<string, NonNullable<UserPermission>>;
